import produce from "immer";
import moment from "moment";

import { ALERT_TYPES, API_RESPONSE_STATUS } from "../config/constants";
import { isArrayValid, isEmptyOrNull, isObjectEmptyOrNull } from "./DataUtils";

import CustomAlert from "../components/common/CustomAlert/CustomAlert";

export const getKeyNameFromZoneTab = (tab: any, keyName: any) => {
  if (tab !== undefined) {
    if (tab.zoneConfig !== undefined && tab.zoneConfig[keyName] !== undefined) {
      return tab.zoneConfig[keyName];
    } else if (tab.zone !== undefined && tab.zone.zoneConfig !== undefined && tab.zone.zoneConfig[keyName] !== undefined) {
      return tab.zone.zoneConfig[keyName];
    }
  }
  return null;
};

export const getBufferCapacityConfigKeyNameFromZoneTab = (tab: any, keyName: any) => {
  if (tab !== undefined) {
    if (tab.zone !== undefined && tab.zone.bufferCapacityConfig !== undefined && tab.zone.bufferCapacityConfig[keyName] !== undefined && tab.zone.bufferCapacityConfig[keyName] !== "") {
      return tab.zone.bufferCapacityConfig[keyName];
    }
  }
  return null;
};

export const getDateKeValueFromZoneTab = (tab: any, keyName: any, momentFormat?: any, requestedFormat?: any) => {
  if (tab !== undefined) {
    if (tab.zoneConfig !== undefined && tab.zoneConfig[keyName] !== undefined) {
      return moment(tab.zoneConfig[keyName], momentFormat);
    } else if (tab.zone !== undefined && tab.zone.zoneConfig !== undefined && tab.zone.zoneConfig[keyName] !== undefined) {
      return moment(tab.zone.zoneConfig[keyName], momentFormat);
    }
  }
  return null;
};

export const is_request_already_presnt_by_admin_util = (configTabs: any, serviceState: any, pendingApprovalRequestRecordListService: any, posDetails: any) => {
  let error_message = "";
  if (
    configTabs !== undefined &&
    Array.isArray(configTabs) &&
    configTabs.length > 0 &&
    serviceState !== undefined &&
    serviceState.selectedConfigTab !== undefined &&
    configTabs[serviceState.selectedConfigTab] !== undefined &&
    configTabs[serviceState.selectedConfigTab].zoneName !== undefined &&
    configTabs[serviceState.selectedConfigTab].zoneName !== "" &&
    pendingApprovalRequestRecordListService !== undefined &&
    pendingApprovalRequestRecordListService.fetchStatus !== undefined &&
    pendingApprovalRequestRecordListService.fetchStatus === API_RESPONSE_STATUS.SUCCEEDED &&
    pendingApprovalRequestRecordListService.data !== undefined &&
    Array.isArray(pendingApprovalRequestRecordListService.data) &&
    pendingApprovalRequestRecordListService.data.length > 0
  ) {
    let obj = pendingApprovalRequestRecordListService.data.find((request: any) => request.posNo === posDetails?.posNo && request.zoneName === configTabs[serviceState.selectedConfigTab].zoneName);
    if (obj !== undefined && obj.requestId !== undefined && obj.requestId !== "") {
      error_message = `Note : A request ${obj.requestId} is already raised for this POS : ${posDetails?.posNo || "POS"} and Zone : ${configTabs[serviceState.selectedConfigTab].zoneName || "Zone"
        } by ${obj.requester || "Admin"}.`;
    }
  }
  return error_message;
};

export const is_request_already_present = (date_data: any, serviceState: any, pendingApprovalRequestRecordListService: any, posNo: any, configTabs: any, serviceTypeName: any) => {
  let obj = {} as any;
  if (
    configTabs !== undefined &&
    serviceState !== undefined &&
    serviceState.selectedConfigTab !== undefined &&
    configTabs[serviceState.selectedConfigTab] !== undefined &&
    configTabs[serviceState.selectedConfigTab].zoneName !== undefined &&
    pendingApprovalRequestRecordListService !== undefined &&
    pendingApprovalRequestRecordListService.fetchStatus !== undefined &&
    pendingApprovalRequestRecordListService.fetchStatus === API_RESPONSE_STATUS.SUCCEEDED &&
    pendingApprovalRequestRecordListService.data !== undefined &&
    Array.isArray(pendingApprovalRequestRecordListService.data) &&
    pendingApprovalRequestRecordListService.data.length > 0
  ) {
    if (date_data !== undefined && date_data !== "") {
      obj = pendingApprovalRequestRecordListService.data.find(
        (request: any) =>
          request.activationDate === date_data &&
          request.posNo === posNo &&
          request.zoneName === configTabs[serviceState.selectedConfigTab].zoneName &&
          request?.serviceType.toLowerCase() === serviceTypeName.toLowerCase()
      );
      if (obj !== undefined && obj.requestId !== undefined && obj.requestId !== "") {
        let error_message = `A request ${obj.requestId} is already raised for this implementation date by ${obj.requester || "Admin"}. Please request action on the same.`;
        CustomAlert(ALERT_TYPES.ERROR, error_message);
      }
    }
  }
  return obj;
};

const getDateFromPicker = (dateData: any) => {
  return moment(dateData).format("YYYY-MM-DD");
};

export const _handle_date_change_event_util = (serviceState: any, event: any, picker: any, pendingApprovalRequestRecordListService: any, posNo: any, configTabs: any, serviceTypeName: any) => {
  return produce(serviceState, (draft: any) => {
    draft.loading = false;

    const startDate = getDateFromPicker(picker?.startDate);
    const isDateSameOrAfterToday = moment(startDate).isSameOrAfter(moment(new Date()).format("YYYY-MM-DD"));

    draft.activationDate = startDate;
    draft.activationDatelabel = startDate;

    if (event?.target?.name === "date" && isDateSameOrAfterToday) {
      const dataPresentObj = is_request_already_present(
        startDate,
        serviceState,
        pendingApprovalRequestRecordListService,
        posNo,
        configTabs,
        serviceTypeName
      );
      draft.isDateValid = isObjectEmptyOrNull(dataPresentObj);
      draft.data_present_obj = dataPresentObj;
    } else {
      draft.isDateValid = false;
      draft.data_present_obj = {};
      if (event?.target?.name === "date" && !isDateSameOrAfterToday) {
        CustomAlert(ALERT_TYPES.ERROR, "Please provide a valid date");
      }
    }
  });
};

export const reset_bulk_update_configuration_for_given_day = (configTab: any, tabIndex: any, generatorFormIndex: any, day: any, serviceState: any) => {
  return produce(configTab, (draft: any) => {
    const originalGeneratorForm = serviceState?.originalConfigTab?.[serviceState.selectedConfigTab]?.slotsGeneratorForms?.[generatorFormIndex];
    const originalDay = originalGeneratorForm?.days?.[0];
    if (!isEmptyOrNull(originalGeneratorForm) && originalDay === day) {
      draft[tabIndex].slotsGeneratorForms[generatorFormIndex] = originalGeneratorForm;
    }
  });
};

export const reset_bulk_update_config_day = (serviceState: any, day: any) => {
  return produce(serviceState, (draft: any) => {
    const days = draft?.configurationBulkUpdatedObj?.bulkUpdatedDays;
    if (isArrayValid(days)) {
      const indexToRemove = days.indexOf(day);
      if (indexToRemove > -1) {
        days.splice(indexToRemove, 1);
      }
    }
  });
};
